module.exports = __webpack_public_path__ + "img/edit_link.590691aa.svg";